/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurableParameterDto } from './ConfigurableParameterDto';
import {
    ConfigurableParameterDtoFromJSON,
    ConfigurableParameterDtoFromJSONTyped,
    ConfigurableParameterDtoToJSON,
    ConfigurableParameterDtoToJSONTyped,
} from './ConfigurableParameterDto';

/**
 * 
 * @export
 * @interface ReadVariablesTunnelDto
 */
export interface ReadVariablesTunnelDto {
    /**
     * Unique identifier of the variable value Id
     * @type {string}
     * @memberof ReadVariablesTunnelDto
     */
    variableValueId: string;
    /**
     * Unique identifier of the variable ref Id
     * @type {string}
     * @memberof ReadVariablesTunnelDto
     */
    variableRefId: string;
    /**
     * The numeric value of the variable
     * @type {number}
     * @memberof ReadVariablesTunnelDto
     */
    value: number;
    /**
     * The code or key identifier for the variable
     * @type {string}
     * @memberof ReadVariablesTunnelDto
     */
    code: string;
    /**
     * The human-readable label or name of the variable
     * @type {string}
     * @memberof ReadVariablesTunnelDto
     */
    label: string;
    /**
     * 
     * @type {ConfigurableParameterDto}
     * @memberof ReadVariablesTunnelDto
     */
    parameters?: ConfigurableParameterDto;
    /**
     * 
     * @type {string}
     * @memberof ReadVariablesTunnelDto
     */
    warningMessage?: string;
}

/**
 * Check if a given object implements the ReadVariablesTunnelDto interface.
 */
export function instanceOfReadVariablesTunnelDto(value: object): value is ReadVariablesTunnelDto {
    if (!('variableValueId' in value) || value['variableValueId'] === undefined) return false;
    if (!('variableRefId' in value) || value['variableRefId'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function ReadVariablesTunnelDtoFromJSON(json: any): ReadVariablesTunnelDto {
    return ReadVariablesTunnelDtoFromJSONTyped(json, false);
}

export function ReadVariablesTunnelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadVariablesTunnelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'variableValueId': json['variableValueId'],
        'variableRefId': json['variableRefId'],
        'value': json['value'],
        'code': json['code'],
        'label': json['label'],
        'parameters': json['parameters'] == null ? undefined : ConfigurableParameterDtoFromJSON(json['parameters']),
        'warningMessage': json['warningMessage'] == null ? undefined : json['warningMessage'],
    };
}

export function ReadVariablesTunnelDtoToJSON(json: any): ReadVariablesTunnelDto {
    return ReadVariablesTunnelDtoToJSONTyped(json, false);
}

export function ReadVariablesTunnelDtoToJSONTyped(value?: ReadVariablesTunnelDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'variableValueId': value['variableValueId'],
        'variableRefId': value['variableRefId'],
        'value': value['value'],
        'code': value['code'],
        'label': value['label'],
        'parameters': ConfigurableParameterDtoToJSON(value['parameters']),
        'warningMessage': value['warningMessage'],
    };
}

